import cn from 'classnames';
import { memo } from 'react';
import { usePartitionsPageRedirect } from '@pages/common/partitions-page/helpers.ts';
import { usePartitionTagsPageRedirect } from '@pages/common/partitions-page/tags-page/helpers.ts';
import { PartitionIcon } from '@shared/assets/icons/partition-icon.tsx';
import { ArrowShortRight } from '@shared/assets/index.ts';
import { usePartitionsWithTagsSelection } from '@shared/hooks/use-partitions-with-tags-selection.ts';
import { FormFieldWithLabelAndPlusBtn } from '@shared/ui/forms/FieldWithLabel/index.ts';
import { Card } from '@shared/ui/index.ts';
import { IconInSquare } from '@shared/ui/smart-icons/IconInSquare/ui.tsx';
import { TextOverflow } from '@shared/ui/TextOverflow/index.tsx';
import { usePartitionsQuery } from '@src/api/api-hooks/common/usePartitionsQuery.ts';
import { Loader } from '@src/library/components/common/index.ts';
import * as st from './styles.module.scss';

type PT = {
  onRedirect?: () => void;
  hash: string;
  label?: string;
  code?: string;
  tagsPageTitle?: string;
  partitionsPageTitle?: string;
};

export const EditorPartitions = memo((props: PT) => {
  const { onRedirect, hash, label = 'РАЗДЕЛ', code, partitionsPageTitle, tagsPageTitle } = props;

  const { partitionsMap, selectedPartitions } = usePartitionsWithTagsSelection({ hash });
  const { data: partitionsQueryData, isLoading } = usePartitionsQuery(code);
  const { goToPartitionsPage } = usePartitionsPageRedirect(code);
  const { goToTagsPage } = usePartitionTagsPageRedirect(code);

  const onAddEntityIds = () => {
    onRedirect && onRedirect();
    goToPartitionsPage({ state: { hash, partitionsPageTitle, tagsPageTitle } });
  };

  const onPartitionClick = (id: number) => {
    onRedirect && onRedirect();
    goToTagsPage({
      partitionId: id,
      navState: { state: { hash, partitionsPageTitle, tagsPageTitle } },
    });
  };
  return (
    <FormFieldWithLabelAndPlusBtn
      label={label}
      onBtnClick={onAddEntityIds}
      withBigButton={selectedPartitions.length === 0}
    >
      {isLoading ? (
        <Loader className={st.loader} />
      ) : (
        <ul className={st.wrapper}>
          {selectedPartitions.map((partitionId) => {
            const partition = partitionsQueryData.find((p) => p.id === partitionId);
            return partition ? (
              <li key={partition.id}>
                <Card className={cn(st.item)} onClick={() => onPartitionClick(partition.id)}>
                  <IconInSquare size={'large'} icon={<PartitionIcon />} />

                  <TextOverflow noWrap>{partition.name}</TextOverflow>

                  <p className={st.tagsLabel}>
                    Теги:{' '}
                    {partitionsMap.has(partition.id) ? partitionsMap.get(partition.id)?.length : 0}
                  </p>

                  <ArrowShortRight className={st.icon} />
                </Card>
              </li>
            ) : null;
          })}
        </ul>
      )}
    </FormFieldWithLabelAndPlusBtn>
  );
});
